// components

// react
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";

// css
import './notiLog_mobile.css';
import styles from './notiLog_mobile.module.css';
import { getNotificationListOne } from '../../../service/pushService';

// services

function NotiLogDetailItemMobile({conn, item}) {

   // 위험발생 타입
  const dangerType = () => {
    if (item.eventType === 11001) {
      return "긴급버튼";
    } else if (item.eventType === 11002) {
      return "음성인식";
    } else if (item.eventType === 11003) {
      return "위험전환"
    } else if (item.eventType === 11004) {
      return "안심존 입장"
    } else if (item.eventType === 11005) {
      return "안심존 퇴장"
    } else if (item.eventType === 11006) {
      return "장비 미작동"
    }
  }
  
  return (
    <div className={styles.notiItem}>
      <div className={styles.leftDiv}>
        <div className={styles.messageDiv}>
          <p className={styles.userTermText}>{item.userTerm}님&nbsp;&nbsp;</p>
          <p className={styles.dangerTypeText}>{dangerType()}&nbsp;</p>
          <p className={styles.basicText}>알림</p>
        </div>
        <p className={styles.dateText}>{kendo.toString(new Date(item.sentDtm), 'yyyy년 MM월 dd일 HH시 mm분')}</p>
      </div>
      <div className={styles.rightDiv}>
        {/* <img className={styles.callImg} src="/images/mobile/call2_btn.png" onClick={callUser}></img> */}
      </div>
    </div>
  );
}

export default NotiLogDetailItemMobile;
